import { DatePicker, Form } from 'antd';
import React from 'react';

import { FORMAT_DATE_DATEPICKER } from '../../const';
import { TableColumnSmxType } from '../../types';

interface IField {
    fieldData: TableColumnSmxType;
}

const FieldDate: React.FC<IField> = ({ fieldData }) => {
    return (
        <Form.Item key={fieldData.key} label={fieldData.title} name={fieldData.key}>
            <DatePicker style={{ width: '100%' }} format={FORMAT_DATE_DATEPICKER} />
        </Form.Item>
    );
};

export default React.memo(FieldDate);
